var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"report-line-text",class:{ 'report-line-text--interactive': !_vm.isReadOnly },domProps:{"innerHTML":_vm._s(_vm.text)}})
}
var staticRenderFns = []

export { render, staticRenderFns }